import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = async (route, state) => {

  const authService = inject(AuthService);

  const path = route.routeConfig?.path;
  if (['callback', 'logout', 'sessionexpired'].includes(path || '')) return true;

  // Save the intended URL before any async operation that could trigger an OAuth redirect.
  // On page refresh at a deep link, this ensures the callback page can restore the correct URL.
  if (state.url && state.url !== '/main') {
    sessionStorage.setItem('returnUrl', state.url);
  }

  if (authService.authState() === 'authenticating') {
    await authService.waitForAuthStabilization();
  }

  const hasValidSession = await authService.validateUserSession(false);
  if (hasValidSession) return true;

  if (authService.authState() === 'unauthenticated') {
    // Force renew tokens if not authenticated
    await authService.validateUserSession(true);
  }
  return authService.authState() === 'authenticated';
};
